import FaqsSubsection from './FaqsSubsection';
import './FaqsSection.scss';

const FaqsSection = ({
  id,
  title,
  subsections,
  selectedFaqs,
  reset,
  setReset
}) => {
  return (
    <div className="faqs-section" id={`sec-${id}`}>
      <div className="faqs-title">{title}</div>
      {subsections &&
        subsections.length > 0 &&
        subsections.map((subSection, subSecInd) => (
          <FaqsSubsection
            key={subSection.id}
            sectionId={id}
            id={subSecInd}
            title={subSection.title}
            faqs={subSection.faqs.map((faq, faqInd) => ({
              ...faq,
              selected: selectedFaqs && !reset
            }))}
            reset={reset}
            setReset={setReset}
          />
        ))}
    </div>
  );
};

export default FaqsSection;
